if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.error = false;
        this.inflight = false;
        this.addToBagLabel = this.readAddToBagLabel();

        if (document.querySelector('cart-drawer') && !this.isGufumartPdp()) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.isGufumartPdp()) {
          this.bindPdpCartSync();
        }
      }

      readAddToBagLabel() {
        var sticky = document.querySelector('.gf-pdp-sticky__bag');
        if (sticky) {
          var spans = sticky.querySelectorAll(':scope > span');
          var label = spans.length ? spans[spans.length - 1] : sticky.querySelector('span');
          var stickyText = label && label.textContent ? label.textContent.trim() : '';
          if (stickyText && !/sold out|unavailable/i.test(stickyText)) return stickyText;
        }
        if (this.submitButtonText && this.submitButtonText.textContent) {
          var ctaText = this.submitButtonText.textContent.trim();
          if (ctaText && !/sold out|unavailable/i.test(ctaText)) return ctaText;
        }
        return 'Add to Bag';
      }

      bindPdpCartSync() {
        if (this._gfCartBound) return;
        this._gfCartBound = true;

        if (window.GufumartCartSync) {
          window.GufumartCartSync.bindLifecycleListeners();
          window.GufumartCartSync.sync().then((cart) => {
            this.syncBagButtonFromCart(cart);
          });
        }

        this._onCartSynced = (event) => {
          this.syncBagButtonFromCart(event.detail && event.detail.cart);
        };
        document.addEventListener('gufumart:cart-synced', this._onCartSynced);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.recheckBagButtonFromShopify();
          });
          this._cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event && event.source === 'product-form') return;
            this.recheckBagButtonFromShopify();
          });
        }

        if (this.variantIdInput) {
          this.variantIdInput.addEventListener('change', () => {
            this.recheckBagButtonFromShopify();
          });
        }
      }

      disconnectedCallback() {
        if (this._onCartSynced) {
          document.removeEventListener('gufumart:cart-synced', this._onCartSynced);
        }
        if (this._variantChangeUnsubscriber) this._variantChangeUnsubscriber();
        if (this._cartUpdateUnsubscriber) this._cartUpdateUnsubscriber();
      }

      recheckBagButtonFromShopify() {
        if (!window.GufumartCartSync) return;
        window.GufumartCartSync.sync().then((cart) => {
          this.syncBagButtonFromCart(cart);
        });
      }

      syncBagButtonFromCart(cart) {
        if (!this.isGufumartPdp()) return;
        var variantId = this.variantIdInput && this.variantIdInput.value;
        var inCart =
          window.GufumartCartSync && window.GufumartCartSync.cartHasVariant(cart, variantId);
        if (inCart) this.setGoToBagState({ animate: false });
        else this.setAddToBagState();
      }

      isGufumartPdp() {
        return !!this.closest('product-info[id^="MainProduct-"]');
      }

      getBagButtons() {
        var buttons = [];
        if (this.submitButton) buttons.push(this.submitButton);
        document.querySelectorAll('.gf-pdp-sticky__bag').forEach(function (btn) {
          if (buttons.indexOf(btn) === -1) buttons.push(btn);
        });
        return buttons;
      }

      isGoToBagState() {
        return this.getBagButtons().some(function (btn) {
          return btn && btn.dataset.gfGoBag === 'true';
        });
      }

      setButtonLabel(btn, text) {
        if (!btn) return;
        if (btn.classList.contains('gf-pdp-sticky__bag')) {
          var spans = btn.querySelectorAll(':scope > span');
          var label = spans.length ? spans[spans.length - 1] : btn.querySelector('span');
          if (label) label.textContent = text;
          else btn.appendChild(document.createTextNode(text));
          return;
        }
        var span = btn.querySelector('span');
        if (span) span.textContent = text;
        else btn.textContent = text;
      }

      setGoToBagState(options) {
        var animate = !options || options.animate !== false;
        this.getBagButtons().forEach(
          function (btn) {
            if (!btn) return;
            btn.dataset.gfGoBag = 'true';
            btn.classList.add('is-go-bag');
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btn.removeAttribute('aria-haspopup');
            this.setButtonLabel(btn, 'GO TO BAG');
            if (animate) {
              btn.classList.remove('is-go-bag-flip');
              // Force reflow so the flip animation restarts on successful add.
              void btn.offsetWidth;
              btn.classList.add('is-go-bag-flip');
            }
          }.bind(this)
        );
      }

      setAddToBagState() {
        this.getBagButtons().forEach(
          function (btn) {
            if (!btn) return;
            btn.dataset.gfGoBag = 'false';
            btn.classList.remove('is-go-bag', 'is-go-bag-flip');
            btn.removeAttribute('aria-haspopup');
            if (!btn.disabled) {
              btn.removeAttribute('aria-disabled');
            }
            this.setButtonLabel(btn, this.addToBagLabel);
          }.bind(this)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isGufumartPdp() && this.isGoToBagState()) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.inflight) return;

        this.handleErrorMessage();

        this.inflight = true;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const isPdp = this.isGufumartPdp();

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !isPdp) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            const afterPublish = publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });

            if (isPdp) {
              // PDP: sync header from /cart.js, never open cart notification/drawer.
              return afterPublish
                .then(() => {
                  if (window.GufumartCartSync) {
                    return window.GufumartCartSync.sync();
                  }
                  return null;
                })
                .then((cart) => {
                  this.setGoToBagState({ animate: true });
                  if (cart) this.syncBagButtonFromCart(cart);
                })
                .catch(() => {
                  this.setGoToBagState({ animate: true });
                });
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.inflight = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.isGoToBagState()) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.isGufumartPdp()) {
            this.recheckBagButtonFromShopify();
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
